module.exports = __webpack_public_path__ + "media/images/icons/icon_filter-fbd5901b8ec02be5aaa44a82c163e4dc.svg";